import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const HeroSliderEightSingle = ({ data }) => {
  return (
    <div
      className="single-slider-2 slider-height-1 d-flex align-items-center slider-height-res hm-13-slider"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + data.image})`
        , backgroundRepeat: 'no-repeat', 
        backgroundSize: 'cover',  
        // backgroundPosition: 'right'
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-8 col-12 ps-5 pe-5">
            <div className="slider-content-13 slider-animated-1">
              <p className="animated titulo">{data.title}</p>
              {/* <h2
                className="animated"
                dangerouslySetInnerHTML={{ __html: data.subtitle }}
              /> */}
              <p className="animated sub-titulo">{data.subtitle}</p>
              <div className="pt-20">
                <Link
                  className="boton-slider"
                  to={process.env.PUBLIC_URL + data.url}
                >
                  Ir a la tienda
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

HeroSliderEightSingle.propTypes = {
  data: PropTypes.shape({})
};

export default HeroSliderEightSingle;
